import { useEffect, useState } from 'react';
import api from '../../api/axios';
import toast from 'react-hot-toast';
import { Sparkles, Loader2, Check, Ghost, TreePine, Sprout, CircleOff } from 'lucide-react';

// Superadmin → Ayarlar: bütün tenantların QR menyusunda mövsümi tema.
// Tenantın öz rəngləri DB-də dəyişmir, yalnız tema seçili olduğu müddətdə üstələnir.
const OPTIONS = [
    { key: '',          label: 'Söndürülüb', desc: 'Hər tenant öz rəngləri ilə',        Icon: CircleOff, active: 'from-slate-700 to-slate-500' },
    { key: 'halloween', label: 'Halloween',  desc: 'Yarasalar, balqabaqlar, hörümçək', Icon: Ghost,     active: 'from-[#2a1438] to-[#7c2d12]' },
    { key: 'newyear',   label: 'Yeni il',    desc: 'Qar, işıqlı çələng, yolka',        Icon: TreePine,  active: 'from-[#0b1a33] to-[#7f1d1d]' },
    { key: 'novruz',    label: 'Novruz',     desc: 'Səməni, tonqal, buta, yumurta',    Icon: Sprout,    active: 'from-[#0f241a] to-[#b45309]' },
];

export default function SuperadminSeasonalCard() {
    const [season, setSeason] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(null); // saxlanan seçimin açarı

    useEffect(() => {
        api.get('/superadmin/qr-seasonal')
            .then((r) => setSeason(r.data?.qr_season || ''))
            .catch(() => toast.error('Mövsümi tema ayarı alınmadı.'))
            .finally(() => setLoading(false));
    }, []);

    const choose = async (key) => {
        if (key === season || saving !== null) return;
        setSaving(key);
        try {
            const r = await api.put('/superadmin/qr-seasonal', { qr_season: key });
            if (!r.data?.ok) throw new Error(r.data?.msg);
            setSeason(key);
            toast.success(r.data.msg);
        } catch (err) {
            toast.error(err.response?.data?.msg || err.message || 'Saxlanmadı');
        } finally {
            setSaving(null);
        }
    };

    return (
        <div className="rounded-2xl border border-slate-200/80 bg-white p-6 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
            <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-orange-50 text-orange-500">
                    <Sparkles className="h-5 w-5" />
                </div>
                <div className="min-w-0 flex-1">
                    <h3 className="text-sm font-semibold text-slate-900">QR menyu: mövsümi tema</h3>
                    <p className="mt-0.5 text-xs leading-relaxed text-slate-500">
                        Seçilən tema bütün tenantların QR menyusunda eyni anda açılır. Tenantların öz rəngləri silinmir.
                        «Söndürülüb» seçəndə hər şey əvvəlki kimi olur.
                    </p>
                </div>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                {OPTIONS.map(({ key, label, desc, Icon, active }) => {
                    const on = season === key;
                    return (
                        <button
                            key={key || 'off'}
                            type="button"
                            disabled={loading || saving !== null}
                            onClick={() => choose(key)}
                            className={`flex items-center gap-3 rounded-xl px-4 py-3 text-left ring-1 transition-colors disabled:cursor-wait ${
                                on ? `bg-gradient-to-r ${active} text-white ring-transparent` : 'bg-slate-50 text-slate-800 ring-slate-200 hover:bg-slate-100'
                            }`}
                        >
                            <Icon className={`h-5 w-5 flex-shrink-0 ${on ? 'text-white' : 'text-slate-400'}`} />
                            <div className="min-w-0 flex-1">
                                <div className="text-sm font-semibold">{label}</div>
                                <div className={`truncate text-xs ${on ? 'text-white/75' : 'text-slate-500'}`}>{desc}</div>
                            </div>
                            {saving === key
                                ? <Loader2 className="h-4 w-4 animate-spin" />
                                : on && <Check className="h-4 w-4" />}
                        </button>
                    );
                })}
            </div>

            <p className="mt-3 text-[11px] leading-relaxed text-slate-400">
                Dəyişiklik QR menyularda ən gec 30 saniyəyə görünür (səhifəni yeniləyin).
                Seçmədən baxmaq üçün QR linkinin sonuna <code className="font-mono">&amp;season=newyear</code>, <code className="font-mono">novruz</code> və ya <code className="font-mono">halloween</code> əlavə edin.
            </p>
        </div>
    );
}
